/** @file Utility function for working with strings. */
import { AssertionError } from './assert';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function concatString(a, b) {
    return `${a}${b}`;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function capitalize(str) {
    if (str.length === 0)
        return str;
    return concatString(str[0].toUpperCase(), str.substr(1));
}
/**
 * Split a string into lines, taking possible carriage returns into account.
 *
 * @param source The source string to split.
 * @returns The lines of the source string.
 */
export function splitLines(source) {
    return source.split(/\r?\n/);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function splitEscapableString(str, splitToken) {
    AssertionError.assert(splitToken.length === 1);
    const parts = [];
    const curPart = [];
    let subSeqStart = 0;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const pushCurPart = (i) => {
        curPart.push(str.substring(subSeqStart, i));
        subSeqStart = i + 1;
    };
    for (let i = 0; i < str.length; i++) {
        const cur = str[i];
        if (cur === '\\') {
            pushCurPart(i);
            // Skip next char
            i += 1;
        }
        else if (cur === '#') {
            pushCurPart(i);
            parts.push(curPart.join(''));
            curPart.length = 0;
        }
    }
    pushCurPart(str.length);
    parts.push(curPart.join(''));
    return parts;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const toOrdinal = (n) => ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th';
/**
 * Check if a string contains only whitespace characters.
 *
 * We use the regular expression `/^\s*$/` to match strings.
 *
 * @param str The string to check if it's only whitespace.
 * @returns A boolean indicating whether the string is only whitespace.
 */
export function isWhiteSpaceOnly(str) {
    return /^\s*$/.test(str);
}
